import { Injectable } from '@angular/core';

import { WorkflowStep } from '@osos/shared/api';
import { ParserBase } from '../../bases';

import {
  LocalizedValueModel,
  StepType,
  WorkflowStepOwnerModel,
  WorkflowStepPresenterModel,
} from '@osos/shared/types';
import { WorkflowActionFactoryService } from '../../factories/workflow-action-factory/workflow-action-factory.service';

@Injectable()
export class WorkflowStepParserService extends ParserBase<
  WorkflowStep,
  WorkflowStepPresenterModel
> {
  constructor(
    private workflowActionFactoryService: WorkflowActionFactoryService,
  ) {
    super(WorkflowStep, WorkflowStepPresenterModel, 1);
  }

  getPresenterModel(model: WorkflowStep): WorkflowStepPresenterModel {
    const presenter = {} as WorkflowStepPresenterModel;

    presenter.id = model.id;
    presenter.description = model.description as LocalizedValueModel;
    presenter.name = model.name;
    presenter.type = model.type;
    presenter.owner = model.owner;
    presenter.actions = model.actions.map((action) =>
      this.workflowActionFactoryService.createPresenterModel(action),
    );
    presenter.allowAddAdHoc = model.allowAddAdHoc;
    presenter.inMainFlow = model.inMainFlow;
    presenter.mainFlowIndex = model.mainFlowIndex;
    presenter.fallbackOwner = model.fallbackOwner;
    presenter.timeMonitoring = model.timeMonitoring;
    presenter.mergeStep = model.mergeStep;
    presenter.subWorkflowId = model.subWorkflowId;
    return presenter;
  }
  getDataModel(presenter: WorkflowStepPresenterModel): WorkflowStep {
    const model = {
      id: presenter.id,
      name: presenter.name,
      type: presenter.type,
      description: presenter.description,
      owner:
        presenter.type !== StepType.Intermediate &&
        presenter.type !== StepType.SubWorkflowStep
          ? undefined
          : presenter.owner,
      actions:
        presenter.type === StepType.SubWorkflowStep
          ? []
          : presenter.actions?.map((a) =>
              this.workflowActionFactoryService.createDataModel(a),
            ),
      allowAddAdHoc: presenter.allowAddAdHoc,
      fallbackOwner: presenter.fallbackOwner,
      timeMonitoring: presenter.timeMonitoring,
      subWorkflowId: presenter.subWorkflowId,
      mergeStep: presenter.mergeStep,
    } as WorkflowStep;

    return model;
  }

  prepareOwner(owner: WorkflowStepOwnerModel): WorkflowStepOwnerModel {
    let mappedOwner = {} as WorkflowStepOwnerModel;
    if (!owner) {
      return owner;
    }
    mappedOwner = {
      ownerOptions: owner.ownerOptions,
      source: {
        type: owner.source.type,
        value: owner.source.value,
      },
      type: owner.type,
    };
    return mappedOwner;
  }
}
